export default __webpack_public_path__ + "static/media/anthem-website-logos_yougov.56a74d09.webp";